import React from 'react';
import { Helmet } from 'react-helmet-async';
import equipoTecnico from '../assets/about/equipo-tecnico-570x350.png';
import proyectoCompletado from '../assets/about/proyecto-completado-570x350.png';
import MapaInteractivo from '../components/MapaInteractivo';

const About = () => {
  return (
    <div className="page">
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Sobre Nosotros | TecnoVigilancia 360 | Expertos en Seguridad Coacalco</title>
        <meta
          name="description"
          content="Empresa especializada en videovigilancia y sistemas de seguridad en Coacalco. Instalación profesional de cámaras HD, mantenimiento CCTV y GPS para flotillas. Personal certificado."
        />
        <meta
          name="keywords"
          content="empresa seguridad Coacalco, videovigilancia profesional, instalación cámaras certificada, CCTV Estado de México, mantenimiento sistemas seguridad, técnicos certificados seguridad"
        />
        <meta property="og:title" content="TecnoVigilancia 360 - Expertos en Seguridad Electrónica" />
        <meta property="og:description" content="Empresa líder en sistemas de videovigilancia en Coacalco con personal certificado y tecnología de punta." />
        <link rel="canonical" href="https://tecnovigilancia360.com/about" />
      </Helmet>

      <section className="page-header">
        <div className="container">
          <h1 className="page-title">Empresa de Sistemas de Seguridad en Coacalco</h1>
          <p className="page-subtitle">
            Conoce más sobre TecnoVigilancia 360 y nuestro compromiso con la seguridad de hogares y negocios
          </p>
        </div>
      </section>

      <section className="about-content">
        <div className="container">
          <div className="about-grid">
            <div className="about-text">
              <h2 className="section-title">Nuestra Trayectoria en Videovigilancia</h2>
              <p className="section-text">
                En <strong>TecnoVigilancia 360</strong> ofrecemos <strong>soluciones profesionales
                de seguridad para hogares, negocios y unidades móviles</strong>. Nos especializamos
                en <strong>sistemas de videovigilancia CCTV</strong> de alta calidad que brindan protección
                completa y tranquilidad a nuestros clientes en todo el Estado de México.
              </p>
              <p className="section-text">
                Ubicados estratégicamente en <strong>Coacalco, Estado de México</strong>,
                servimos a toda la zona metropolitana con <strong>instalaciones profesionales de
                cámaras de seguridad</strong>, servicio de renta accesible desde $400 mensuales y
                <strong> mantenimiento especializado de sistemas CCTV</strong>.
              </p>
              <p className="section-text">
                Nuestro equipo está conformado por <strong>técnicos certificados con amplia
                experiencia en sistemas de seguridad electrónica</strong>, rastreo GPS para flotillas
                y videovigilancia de última generación con <strong>cámaras HD</strong> de alto rendimiento.
              </p>
            </div>

            <div className="about-image">
              <img
                src={equipoTecnico}
                alt="Equipo técnico certificado de TecnoVigilancia 360 - Expertos en instalación de cámaras de seguridad"
                style={{ width: '100%', height: 'auto', borderRadius: '8px', objectFit: 'cover' }}
              />
            </div>
          </div>

          {/* Imagen: Proyecto de instalación completado */}
          <div style={{ marginTop: '3rem' }}>
            <img
              src={proyectoCompletado}
              alt="Proyecto de instalación de videovigilancia profesional completado - TecnoVigilancia 360"
              style={{ width: '100%', height: 'auto', maxHeight: '350px', objectFit: 'cover', borderRadius: '8px' }}
            />
          </div>
        </div>
      </section>

      <section className="mission-vision">
        <div className="container">
          <div className="mv-grid">
            <div className="mv-card">
              <div className="mv-icon">🎯</div>
              <h3 className="mv-title">Nuestra Misión</h3>
              <p className="mv-text">
                Proporcionar <strong>soluciones integrales de seguridad con soporte técnico
                especializado</strong> y tecnología de vanguardia, ofreciendo un servicio personalizado
                y profesional que garantice la protección de hogares, negocios y vehículos de nuestros
                clientes en Coacalco y todo el Estado de México.
              </p>
            </div>

            <div className="mv-card">
              <div className="mv-icon">👁️</div>
              <h3 className="mv-title">Nuestra Visión</h3>
              <p className="mv-text">
                Ser la <strong>empresa líder en sistemas de seguridad y videovigilancia en
                el Estado de México</strong>, reconocida por nuestra excelencia en el servicio,
                innovación tecnológica con <strong>cámaras HD y sistemas CCTV profesionales</strong>,
                y compromiso inquebrantable con la tranquilidad de nuestros clientes.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="values-section">
        <div className="container">
          <h2 className="section-title">Valores que nos Definen como Expertos en Seguridad</h2>
          <div className="values-grid">
            <div className="value-item">
              <div className="value-icon">✓</div>
              <h4>Confiabilidad</h4>
              <p>Equipos CCTV de calidad profesional y servicio garantizado</p>
            </div>
            <div className="value-item">
              <div className="value-icon">✓</div>
              <h4>Profesionalismo</h4>
              <p>Personal técnico certificado en instalación de cámaras de seguridad</p>
            </div>
            <div className="value-item">
              <div className="value-icon">✓</div>
              <h4>Innovación</h4>
              <p>Tecnología de última generación en videovigilancia HD</p>
            </div>
            <div className="value-item">
              <div className="value-icon">✓</div>
              <h4>Compromiso</h4>
              <p>Dedicados a la seguridad de hogares y negocios 24/7</p>
            </div>
          </div>
        </div>
      </section>

      <section className="location-section">
        <div className="container">
          <h2 className="section-title">Ubicación Estratégica en Coacalco</h2>
          <p className="section-text center">
            Nos encontramos en <strong>Coacalco, Estado de México</strong>, listos para atenderte
            de Lunes a Sábado de 9:00 AM a 6:00 PM con instalación y soporte técnico de videovigilancia
          </p>
          <div className="location-image">
            <MapaInteractivo height="450px" />
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
